import '../explore'; // syndication includes explore
import './styles/custom_properties.scss';
import '../Components/Blanco';
import '../Components/Graphik';
import './Components/ArticleContent';
import './Components/ArticleFooter';
import './Components/ArticleHeader';
import './Components/ArticlePage';
import './Components/Attribution';
import './Components/Comments';
import './Components/Ad';
import './Components/JoinUs';
import './Components/PersistentActions';
import './Components/PublisherLinks';
import './Components/PublisherCta';
import './Components/MoreFromPocket';

import CookieTrackingBootstrapper from './cookieTracking';

/**
 * Remove all inline styles from
 *
 * TODO: Replace this with server side logic.
 */
const articleRemoveImageStyles = () => {
  document.querySelectorAll('.article-content img[style]').forEach(el => {
    el.setAttribute('style', '');
  });
}

const articleEnableShareLinks = () => {
  const twitter = document.querySelector('.share-twitter');
  const facebook = document.querySelector('.share-facebook');
  const fallbackUrl = '/explore/must-reads';

  let socialWindows = {};

  const openRequestedPopup = (strUrl, strWindowName, height = 460, width = 520) => {
    const ref = socialWindows.hasOwnProperty(strWindowName) ? socialWindows[strWindowName] : null;

    if (ref === null || ref.closed) {
      socialWindows[strWindowName] = window.open(strUrl, strWindowName,
          `resizable=yes,scrollbars=yes,status=yes,height=${height},width=${width}`);
    } else {
      if (ref.focus) {
        ref.focus();
      }
    }
  };

  facebook.addEventListener('click', e => {
    const destinationUrl = e.target.getAttribute('href') || fallbackUrl;
    openRequestedPopup(destinationUrl, 'FacebookWindow', 570);
  });

  twitter.addEventListener('click', e => {
    const destinationUrl = e.target.getAttribute('href') || fallbackUrl;
    openRequestedPopup(destinationUrl, 'TwitterWindow');
  });
}

document.addEventListener("DOMContentLoaded", function (event) {
  articleRemoveImageStyles();
  articleEnableShareLinks();
  CookieTrackingBootstrapper();
});

